import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { useEffect as r } from "react";
import { H as s } from "./chunks/index-UjijAVoZ.js";
import l from "./Loader.js";
const f = ({ children: o = "Please do not refresh the page" }) => (r(() => (document.body.classList.add("overflow-hidden"), window.scrollTo(0, 0), () => {
  document.body.classList.remove("overflow-hidden");
}), []), /* @__PURE__ */ t("div", { className: "absolute bg-neutral-50 flex flex-col gap-4 h-full items-center justify-center left-0 top-0 w-full z-40", children: [
  /* @__PURE__ */ e(l, {}),
  /* @__PURE__ */ e(s, { className: "container-sm text-center", level: "5", tagName: "span", children: o })
] }));
export {
  f as default
};
